import React, { memo } from 'react';
import Head from 'next/head';

const MedicalConditionsJson: React.FC<{
  title: string;
  description: string;
  url: string;
  name: string;
  alternateName?: string[];
  datePublished: string;
  author: string;
  authorJobTitle: string;
  reviewedBy: string;
  reviewerJobTitle: string;
  lastReviewed: string;
  specialty?: string;
}> = memo(
  ({
    title,
    description,
    url,
    name,
    alternateName,
    datePublished,
    author,
    authorJobTitle,
    reviewedBy,
    reviewerJobTitle,
    lastReviewed,
    specialty,
  }) => {
    const about = {
      '@type': 'MedicalCondition',
      name,
      ...(alternateName && alternateName.length > 0 ? { alternateName } : {}),
    };

    const details = {
      '@context': 'http://schema.org/',
      '@type': 'MedicalWebPage',
      name: title,
      description: description,
      url: url,
      dateModified: lastReviewed,
      datePublished: datePublished,
      inLanguage: 'en-US',
      author: { '@type': 'Person', name: author, jobTitle: authorJobTitle },
      about,
      reviewedBy: {
        '@type': 'Person',
        name: reviewedBy,
        jobTitle: reviewerJobTitle,
        affiliation: {
          '@type': 'Organization',
          name: 'Leafwell',
          url: 'https://leafwell.com',
        },
      },
      publisher: {
        '@type': 'Organization',
        name: 'Leafwell',
        url: 'https://leafwell.com',
      },
      medicalAudience: { '@type': 'MedicalAudience', audienceType: 'Patient' },
      ...(specialty
        ? { specialty: { '@type': 'MedicalSpecialty', name: specialty } }
        : {}),
    };

    return React.createElement(
      Head,
      null,
      React.createElement('script', {
        type: 'application/ld+json',
        dangerouslySetInnerHTML: {
          __html: JSON.stringify(details),
        },
      }),
    );
  },
);

export default MedicalConditionsJson;
